import type {FC} from 'react';
import moment from 'moment';
import {StatusChip} from './StatusChip';
import {headerPalette} from './palette';

interface CheckinStatusChipProps {
  // Timestamp of the member's most recent check-in, if any
  lastCheckIn?: string | null;
}

const WARNING_DAYS = 7;
const ERROR_DAYS = 21;

const chipState = (lastCheckIn?: string | null) => {
  if (!lastCheckIn) {
    return {
      icon: 'MinusCircle',
      label: 'Never checked in',
      background: headerPalette.neutralBg,
      foreground: headerPalette.textSecondary,
    };
  }

  const days = moment().diff(lastCheckIn, 'days');

  if (days === 0) {
    return {
      icon: 'CheckCircle',
      label: 'Checked in today',
      background: headerPalette.successBg,
      foreground: headerPalette.successFg,
    };
  }

  if (days < WARNING_DAYS) {
    return {
      icon: 'CheckCircle',
      label: `Checked in ${days} ${days === 1 ? 'day' : 'days'} ago`,
      background: headerPalette.successBg,
      foreground: headerPalette.successFg,
    };
  }

  return {
    icon: days < ERROR_DAYS ? 'Clock' : 'WarningCircle',
    label: `No check-in for ${days} days`,
    background:
      days < ERROR_DAYS ? headerPalette.warningBg : headerPalette.errorBg,
    foreground:
      days < ERROR_DAYS ? headerPalette.warningFg : headerPalette.errorFg,
  };
};

export const CheckinStatusChip: FC<CheckinStatusChipProps> = ({
  lastCheckIn,
}) => {
  const state = chipState(lastCheckIn);

  return <StatusChip {...state} testId="checkin-status-chip" />;
};
